module.exports = __webpack_public_path__ + "static/media/lungs.947f95fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/BodyView/lungs.svg
// module id = 356
// module chunks = 0